export default {
  getAll(context, data) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(data.params).toString();

      return window.axios
        .get(`/modules/quizzes/u/list/${data.module_id}?${queryString}`)
        .then(response => {
          if (!data?.not_use_store) {
            context.commit("setQuizes", response.data);
          }
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getQuizFinal(context) {
    const productId = context.rootState.setup.product_id;
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/modules/final_quiz/${productId}`)
        .then(({ data }) => {
          context.commit("setFinalQuiz", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  startQuiz(context, quiz_code) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/exams/scores`, { quiz_code })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  setProgress(context, quiz_code) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/exams/progress/`, { quiz_code })
        .then(({ data }) => {
          context.commit("setFinalQuiz", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  saveAnswer(context, { score_code, quiz_code, quiz_answers }) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/exams/scores/${score_code}`, {
          quiz_code,
          quiz_answers
        })
        .then(({ data }) => {
          context.commit("setFinalQuiz", data);
          resolve(data);
        })
        .catch(reject);
    });
  }
};
